import { render } from "./RequestOrderFormPage.vue?vue&type=template&id=2cb6cbcb&scoped=true"
import script from "./RequestOrderFormPage.vue?vue&type=script&lang=js"
export * from "./RequestOrderFormPage.vue?vue&type=script&lang=js"

import "./RequestOrderFormPage.vue?vue&type=style&index=0&id=2cb6cbcb&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb6cbcb"]])

export default __exports__